module.exports = __webpack_public_path__ + "media/Video05_passive.582866b3.mp4";